export interface RessourceSetting {
    ressourceId: string;
    ressourceType: RessourceTypeEnum
    settingKey: string;
    settingValue?: string;
    settingType?: string;
}

export enum RessourceTypeEnum {
  Ressource = "ressource",
  Profil = "profil",
  Cabinet = "cabinet",
}
